// @flow
export const QueryTypes = {
  LECTURE: 'Lecture',
  COURSE: 'Course',
  TRIP: 'Trip',
  GIFT_CARD: 'Gift card',
  SERVICE: 'Service'
}

export type QueryType = $Keys<typeof QueryTypes>

export const LocationTypes = {
  GEO_LOCATION: 'geo_location',
  LOCATION: 'location',
  COURSE_NAME: 'course_name',
}

export type LocationType = $Keys<typeof LocationTypes>

export type Location = {
  type: string,
  label: string,
  id: string,
}

export type Query = {
  date_from?: string,
  date_to?: string,
  course: string,
  course_id: Array<string>,
  audience_id: Array<string>,
  organizer_id: Array<string>,
  location: Location,
  type: QueryType,
  text: string,
};



// WEBPACK FOOTER //
// ./src/modules/search/types.js